import ioiLogo from "@/assets/img/common/sponsor_logos/ioi/IOI_white_large.png";
import idaLogo from "@/assets/img/common/sponsor_logos/ida/IDA_Logo_2.png";

export default [
  {
    id: "ida",
    name: "IDA",
    website: "https://ida.dk/",
    logo: idaLogo,
    text: "Med over 40.000 studiemedlemmer er IDA Danmarks største fællesskab af studerende inden for it, naturvidenskab og ingeniørfag. Vi arbejder på at give dig og dine medstuderende den bedst mulige studietid og de bedste forudsætninger for at få en god start på karrieren. I løbet af studietiden og over i første job står vi klar med faglig rådgivning og sparring, der kan være med til at sikre at du står stærkest på arbejdsmarkedet.",
  },
  {
    id: "ioi",
    name: "IO Interactive",
    website: "https://ioi.dk/",
    logo: ioiLogo,
    text: "IO Interactive is an independent game development studio best known for the HITMAN franchise and the recently released 007 First Light, which launched to critical acclaim and became the highest-rated game in the studio's history. From our studios across Europe, including Copenhagen, we create immersive experiences for millions of players worldwide. We are proud to support ITU's LAN party and the next generation of gaming enthusiasts, developers, and creators.",
  },
    
];